import { render, staticRenderFns } from "./AiSidebar.vue?vue&type=template&id=070ad8b9&scoped=true"
import script from "./AiSidebar.vue?vue&type=script&lang=js"
export * from "./AiSidebar.vue?vue&type=script&lang=js"
import style0 from "./AiSidebar.vue?vue&type=style&index=0&id=070ad8b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ad8b9",
  null
  
)

export default component.exports